import validator from 'validatorjs';

function validate(cnpj: string) {

  cnpj = (cnpj || '').replace(/\D/gi, '');

  if (cnpj.length != 14) {
    return false;
  }

  if (cnpj === cnpj[0].repeat(14)) {
    return false;
  }

  let tamanho = cnpj.length - 2;
  let numeros = cnpj.substring(0, tamanho);
  const digitos = cnpj.substring(tamanho);
  let soma = 0;
  let pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i--) {
    soma += Number(numeros.charAt(tamanho - i)) * pos--;
    if (pos < 2)
      pos = 9;
  }
  let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
  if (resultado != Number(digitos.charAt(0))) {
    return false;
  }

  tamanho = tamanho + 1;
  numeros = cnpj.substring(0, tamanho);
  soma = 0;
  pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i--) {
    soma += Number(numeros.charAt(tamanho - i)) * pos--;
    if (pos < 2)
      pos = 9;
  }

  resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
  return (resultado == Number(digitos.charAt(1)));
}

validator.register('cnpj', validate, 'invalid_cnpj');


// WEBPACK FOOTER //
// ./src/validators/cnpj.ts